import React from "react";

export default function Sponsors() {
  return (
    <div className="container" style={{ overflow: "hidden" }}>
      <h4 className="card-title">Marques disponibles</h4>
      <div className="h-200 d-flex align-items-center justify-content-center">
        <img src="/images/sponsors.jpg" />
      </div>
    </div>
  );
}
